import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FileUploadService } from './file-upload.service';
import { DataService } from '../data/data.service';

@Injectable({
  providedIn: 'root',
})
export class UploadFileService {
  constructor(
    private fileUploadService: FileUploadService,
    private dataService: DataService
  ) {}

  uploadFile(file: any) {
    const url = '/Utils/FileUpload';
    return this.fileUploadService.uploadFile(url, file);
  }

  getTemplate(collection) {
    const url = `Imports/ImportTemplate/${collection}`;
    return this.dataService.getFile(url).toPromise();
  }

  initUploadFile(file: any) {
    const url = '/api/internal/Utils/fileupload';
    return this.fileUploadService.uploadFile(url, file);
  }

  runImport(entity: string, uri: string, sharedValue?: any, collection?: string, entitySingular?: string) {
    const body = { Url: uri, CollectionName: entitySingular || collection };
    sharedValue && (body['sharedValue'] = sharedValue);
    const url = 'Imports/run';
    return this.dataService.post(url, body);
  }

  /**
   * NEMSIS XML files hold PHI, so they go to the API's private NEMSIS inbox instead of the
   * public docs container. The API deletes the file once the import succeeds.
   */
  uploadNemsisFile(file: any): Observable<{ blobName: string }> {
    const url = '/api/internal/Imports/nemsis-file';
    return this.fileUploadService.uploadFile(url, file).pipe(map((res: any) => ({ blobName: res.blobName })));
  }

  runNemsisImport(blobName: string, sharedValue?: any) {
    const body = { BlobName: blobName, CollectionName: 'Invoice' };
    sharedValue && (body['sharedValue'] = sharedValue);
    return this.dataService.post('Imports/run', body);
  }

  deleteImport(importId: string) {
    const url = `Imports/${importId}`;
    return this.dataService.delete(url);
  }
}
